import React, { useState, useEffect } from 'react';
import Table from '../../../app/components/Table';
import Pagination from '../../../app/components/Pagination';
import { FiEdit, FiPlus } from 'react-icons/fi';
import FormEditCollaborator from '../../../forms/Collaborators/FormEditCollaborator';
import Button from '../../../app/components/Button';
import Input from '../../../app/components/Input';
import Toast from '../../../app/components/Toast';
import { usePageTitle } from '../../../contexts/PageTitleContext';


const Collaborators = () => {
  const { setTitle } = usePageTitle();
    
  useEffect(() => {
    setTitle('Colaboradores');
  }, [setTitle]);

  const [isFormOpen, setIsFormOpen] = useState(false);
  const [selectedCollaborator, setSelectedCollaborator] = useState(null);
  const [searchTerm, setSearchTerm]  = useState('')
  const [toast, setToast] = useState({ show: false, type: 'success', message: '' });

  const [collaborators, setCollaborators] = useState([
    { id: 1, nome: 'João Silva', email: 'joao.silva@empresa.com', nivel: 'Gerente', departamento: 'Financeiro', telefone: '(11) 98765-4321' },
    { id: 2, nome: 'Maria Oliveira', email: 'maria.oliveira@empresa.com', nivel: 'Analista', departamento: 'Recursos Humanos', telefone: '(11) 91234-5678' },
    { id: 3, nome: 'Pedro Santos', email: 'pedro.santos@empresa.com', nivel: 'Coordenador', departamento: 'Desenvolvimento', telefone: '(11) 92345-6789' },
    { id: 4, nome: 'Ana Pereira', email: 'ana.pereira@empresa.com', nivel: 'Assistente', departamento: 'Marketing', telefone: '(11) 93456-7890' },
    { id: 5, nome: 'Carlos Mendes', email: 'carlos.mendes@empresa.com', nivel: 'Gerente', departamento: 'Comercial', telefone: '(11) 94567-8901' },
    { id: 6, nome: 'Fernanda Lima', email: 'fernanda.lima@empresa.com', nivel: 'Analista', departamento: 'Financeiro', telefone: '(11) 95678-9012' },
    { id: 7, nome: 'Roberto Costa', email: 'roberto.costa@empresa.com', nivel: 'Diretor', departamento: 'Executivo', telefone: '(11) 96789-0123' },
    { id: 8, nome: 'Luciana Martins', email: 'luciana.martins@empresa.com', nivel: 'Assistente', departamento: 'Recursos Humanos', telefone: '(11) 97890-1234' },
    { id: 9, nome: 'Marcos Almeida', email: 'marcos.almeida@empresa.com', nivel: 'Desenvolvedor', departamento: 'Desenvolvimento', telefone: '(11) 98901-2345' },
    { id: 10, nome: 'Juliana Soares', email: 'juliana.soares@empresa.com', nivel: 'Designer', departamento: 'Marketing', telefone: '(11) 99012-3456' },
  ]);

  const [paginaAtual, setPaginaAtual] = useState(1);
  const itensPorPagina = 10;

  const colunas = [
    { titulo: 'ID', campo: 'id' },
    { titulo: 'NOME', campo: 'nome' },
    { titulo: 'EMAIL', campo: 'email' },
    { titulo: 'NÍVEL', campo: 'nivel', apenasDesktop: true },
    { titulo: 'DEPARTAMENTO', campo: 'departamento' },
    { titulo: 'TELEFONE', campo: 'telefone', apenasDesktop: true },
    { titulo: 'AÇÕES', tipo: 'acoes', centralizado: true },
  ];

  const showToast = (type, message) => {
    setToast({ show: true, type, message });
  };

  const handleEdit = (collaborator) => {
    setSelectedCollaborator(collaborator);
    setIsFormOpen(true);
  };

  const handleNewCollaborator = () => {
    setSelectedCollaborator(null);
    setIsFormOpen(true);
  };

  const handleFormClose = () => {
    setIsFormOpen(false);
    setSelectedCollaborator(null);
  };

  const handleFormSubmit = (formData) => {
    if (formData.id) {
      setCollaborators(collaborators.map(col =>
        col.id === formData.id ? { ...formData } : col
      ));
      showToast('success', 'Colaborador atualizado com sucesso!');
    } else {
      const newId = Math.max(...collaborators.map(col => col.id), 0) + 1;
      setCollaborators([...collaborators, { ...formData, id: newId }]);
      showToast('success', 'Novo colaborador adicionado com sucesso!');
    }
    setIsFormOpen(false);
  };

  const getActionsForCollaborator = (collaborator) => [
    {
      icon: FiEdit,
      label: 'Editar',
      onClick: () => handleEdit(collaborator)
    },
  ];

  const collaboratorsWithActions = collaborators.map(collaborator => ({
    ...collaborator,
    acoes: getActionsForCollaborator(collaborator)
  }));

  const collaboratorsFiltrados = collaboratorsWithActions.filter(collaborator =>
    collaborator.nome.toLowerCase().includes(searchTerm.toLowerCase()) ||
    collaborator.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
    collaborator.departamento.toLowerCase().includes(searchTerm.toLowerCase())
  );


  const totalPages = Math.ceil(collaboratorsFiltrados.length / itensPorPagina);
  const indiceInicial = (paginaAtual - 1) * itensPorPagina;
  const indiceFinal = indiceInicial + itensPorPagina;
  const collaboratorsPaginados = collaboratorsFiltrados.slice(indiceInicial, indiceFinal);

  const handlePageChange = (page) => {
    setPaginaAtual(page);
  };

  return (
    <div>
      <div className="flex flex-row items-stretch w-full gap-2 justify-between mb-10 mt-8">
              <Button
                className="flex items-center justify-center h-9 w-9 !px-5 sm:h-auto sm:w-auto sm:px-6"
                onClick={handleNewCollaborator}
              >
                <span className="sm:hidden text-lg"><FiPlus size={17}/></span>
                <span className="hidden sm:inline">Novo Colaborador</span>
              </Button>

              <Input
                type="text"
                size="xs"
                variant="search"
                value={searchTerm}
                label="Pesquisar"
                onChange={(e) => setSearchTerm(e.target.value)}
                className="flex-1"
              />
            </div>

      <div className="overflow-x-auto -mx-3 sm:mx-0">
        <Table 
          colunas={colunas}
          dados={collaboratorsPaginados}
        />
      </div>

      {collaboratorsFiltrados.length > 0 && (
        <Pagination 
          currentPage={paginaAtual} 
          totalPages={totalPages} 
          onPageChange={handlePageChange}
          showPageNumbers={true}
          maxPageNumbers={5}
        />
      )}

      {toast.show && (
        <Toast
          type={toast.type}
          message={toast.message}
          duration={3000}
          onClose={() => setToast({ ...toast, show: false })}
        />
      )}


      <FormEditCollaborator 
        isOpen={isFormOpen}
        onClose={handleFormClose}
        title={selectedCollaborator ? "Editar Colaborador" : "Novo Colaborador"}
        selectCollaborator={selectedCollaborator}
        onSubmit={handleFormSubmit}
      />
    </div>
  );
};

export default Collaborators;